import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CreateWizardLayout from '../../../../../components/CreateWizardLayout';
import Alert from '../../../../../../../components/global/Alert';
import { getFormikTouchedErrors } from '../../../../../../../util/formik';
import AlbumItem from './components/AlbumItem';
import BoxedItem from '../../../../../../../components/global/BoxedItem';
import Button from '../../../../../../../components/global/Button';
import PlusIcon from '../../../../../../../components/icons/PlusIcon';
import FormGroup from '../../../../../../../components/global/FormGroup';
import uuidv4 from '../../../../../../../util/uuid';

const propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  touched: PropTypes.object,
};

const FreemiumEventCreateAlbumsStep = ({
  values,
  errors,
  handleChange,
  touched,
}) => {
  const errorList = Object.values(getFormikTouchedErrors(errors, touched));
  const [albumCreateEnabled, setAlbumCreateEnabled] = useState(false);
  const [albumCreateInput, setAlbumCreateInput] = useState('');
  const { albums } = values;

  const albumCreateInputClasses = classNames({
    'p-3 no-shadow': true,
    'd-none': !albumCreateEnabled,
  });

  const onAlbumCreate = () => {
    handleChange({
      target: {
        name: 'albums',
        value: [
          ...albums,
          {
            name: albumCreateInput,
            id: uuidv4(),
            selected: true,
            removable: true,
            available: true,
            photo_album: true,
          },
        ],
      },
    });

    setAlbumCreateEnabled(false);
    setAlbumCreateInput('');
  };

  return (
    <CreateWizardLayout.Wrapper>
      <CreateWizardLayout.Content>
        <div>
          {albums.map(album => {
            return (
              <AlbumItem
                key={album.id}
                album={album}
                isSelected={album.selected}
                onChange={() => {
                  handleChange({
                    target: {
                      name: 'albums',
                      value: albums.map(item =>
                        item.id === album.id
                          ? { ...item, selected: !item.selected }
                          : item,
                      ),
                    },
                  });
                }}
              />
            );
          })}

          {!albumCreateEnabled && (
            <Button
              btnStyle="link"
              onClick={() => {
                setAlbumCreateEnabled(true);
              }}
              className="mt-2 d-flex mx-auto"
            >
              <PlusIcon size="15px" color="#0d84fe" className="mr-1" /> Add a
              custom album&hellip;
            </Button>
          )}

          {albumCreateEnabled && (
            <BoxedItem color="blue-light" className={albumCreateInputClasses}>
              <FormGroup
                id="album-create-name"
                type="text"
                label="New Album Name"
                name="album-name"
                labelType="expanded"
                labelSrOnly
                value={albumCreateInput}
                className="text-primary mb-0"
                onKeyDown={event => {
                  if (event.key === 'Enter') {
                    event.stopPropagation();

                    if (albumCreateInput.length) {
                      onAlbumCreate();
                    } else {
                      setAlbumCreateEnabled(false);
                      setAlbumCreateInput('');
                    }
                  }
                }}
                onChange={event => setAlbumCreateInput(event.target.value)}
                onBlur={() => {
                  if (albumCreateInput.length) {
                    onAlbumCreate();
                  } else {
                    setAlbumCreateEnabled(false);
                    setAlbumCreateInput('');
                  }
                }}
                autoFocus
              />
              <div className="mt-1 d-flex">
                <Button
                  className="ml-auto mr-1 text-extra-bold"
                  btnStyle="link"
                  onClick={onAlbumCreate}
                >
                  Save
                </Button>
                <Button
                  btnStyle="link"
                  onClick={() => {
                    setAlbumCreateEnabled(false);
                    setAlbumCreateInput('');
                  }}
                  className="text-extra-bold text-danger"
                >
                  Cancel
                </Button>
              </div>
            </BoxedItem>
          )}
        </div>
        {errorList.length > 0 && (
          <Alert type="danger" className="mt-1 text-normal">
            <ul className="mb-0">
              {errorList.map(error => (
                <li key={error}>{error}</li>
              ))}
            </ul>
          </Alert>
        )}
      </CreateWizardLayout.Content>
    </CreateWizardLayout.Wrapper>
  );
};

FreemiumEventCreateAlbumsStep.propTypes = propTypes;

export default FreemiumEventCreateAlbumsStep;
